<template>
  <landing-page>
    <template #heading>
      Video editing professional?
    </template>
    <template #tagline>
      <template v-if="trialMode">
        Get 50% off our Commercial and Extended plans for life and a 30-day free trial you can cancel at anytime at no charge.
      </template>
      <template v-else>
        Get 50% off our Commercial and Extended plans for life.
      </template>
      <br>
      <strong>Use code FIRST100 at checkout</strong>
    </template>

    <template #section-1-heading>
      The best royalty free music you can find
    </template>
    <template #section-1-text>
      Don't settle for stock. Each of our 3 plans give you unlimited access to download and use quality royalty free music from real artists, and keeps the process simple &mdash; all at an unbeatable price.
    </template>

    <template #section-2-heading>
      Committed to quality music
    </template>
  </landing-page>
</template>

<script>
import LandingPage from '@/components/LandingPage.vue'

export default {
  name: 'LandingPageVideoEditor',

  components: {
    LandingPage
  },

  computed: {
    trialMode: function () {
      return this.$store.getters['subscriptions/createSubscriptionWithTrial']
    }
  }
}
</script>
